module.exports = __webpack_public_path__ + "img/dsci0056.c59f5ee1.jpg";